import { render } from "./Builder.vue?vue&type=template&id=29bc9b24"
import script from "./Builder.vue?vue&type=script&lang=js"
export * from "./Builder.vue?vue&type=script&lang=js"
script.render = render

export default script